module.exports = __webpack_public_path__ + "img/Arrow_Left2.de2ed562.svg";